import { LayaGL } from "../../../layagl/LayaGL";
import { RenderState2D } from "../../../webgl/utils/RenderState2D";
import { Command2D } from "./Command2D";
export class Set2DRTCMD extends Command2D {
    static create(renderTexture, clearColor, colorValue, renderInvertY = true) {
        var cmd;
        cmd = Set2DRTCMD._pool.length > 0 ? Set2DRTCMD._pool.pop() : new Set2DRTCMD();
        cmd.renderTexture = renderTexture;
        cmd._setRenderTargetCMD.clearColor = clearColor;
        cmd._setRenderTargetCMD.clearColorValue = colorValue;
        cmd._setRenderTargetCMD.invertY = renderInvertY;
        return cmd;
    }
    get renderTexture() {
        return this._renderTexture;
    }
    set renderTexture(value) {
        this._renderTexture = value;
        this._setRenderTargetCMD.rt = value ? value._renderTarget : null;
    }
    constructor() {
        super();
        this._renderTexture = null;
        this._setRenderTargetCMD = LayaGL.render2DRenderPassFactory.createSetRendertarget2DCMD();
    }
    run() {
        if (this._renderTexture)
            this._commandBuffer._renderSize.setValue(this._renderTexture._renderTarget._textures[0].width, this._renderTexture._renderTarget._textures[0].height);
        else {
            this._commandBuffer._renderSize.setValue(RenderState2D.width, RenderState2D.height);
        }
    }
    getRenderCMD() {
        return this._setRenderTargetCMD;
    }
    recover() {
        Set2DRTCMD._pool.push(this);
        this._renderTexture = null;
    }
}
Set2DRTCMD._pool = [];
